import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
	GET_BANNER_DETAILS_REQUEST: '',
	GET_BANNER_DETAILS_SUCCESS: '',
	GET_BANNER_DETAILS_FAILURE: ''
};

types = setStoreTypeValues(types, 'banner');

export default types;
